module.exports = __webpack_public_path__ + "static/img/list-anticipos.9c4b98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list-anticipos.png
// module id = a0gs
// module chunks = 1